import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllDocumentsDocumentTagEnum,
  PatientDocumentControllerApi,
} from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  documentTag?: GetAllDocumentsDocumentTagEnum;
  appointmentId?: string;
  patientId: string;
  status?: boolean;
  assigned?: boolean;
  archive?: boolean;
  xTENANTID?: string;
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  searchString?: string;
  isPublicView?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientDocumentList = ({
  isPublicView = false,
  documentTag,
  appointmentId,
  patientId,
  status,
  assigned,
  archive,
  xTENANTID,
  pagination,
  gridSorting,
  searchString,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  return useQuery({
    queryKey: [
      "patient-document-list",
      documentTag,
      appointmentId,
      patientId,
      pageIndex,
      pageSize,
      status,
      assigned,
      archive,
      gridSorting,
      searchString,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new PatientDocumentControllerApi(
        isPublicView ? undefined : getConfigObject()
      )
        .getAllDocuments(
          pageIndex,
          pageSize,
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          status,
          assigned,
          archive,
          documentTag,
          appointmentId,
          patientId,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
